import type { LucideIcon } from 'lucide-react'

import { Card, CardContent } from '@/components/ui'
import { AnimatedNumber } from './AnimatedNumber'

interface MetricCardProps {
  label: string
  value: number
  icon?: LucideIcon
  prefix?: string
  suffix?: string
  decimals?: number
  useLocale?: boolean
  subtitle: string
}

export function MetricCard({
  label,
  value,
  icon: Icon,
  prefix,
  suffix,
  decimals,
  useLocale,
  subtitle,
}: MetricCardProps) {
  return (
    <Card>
      <CardContent className="flex flex-col gap-3 p-5">
        <div className="flex items-center justify-between">
          <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-blue-5">
            {label}
          </p>
          {Icon ? (
            <span className="flex size-8 items-center justify-center rounded-lg bg-blue-2/60 text-blue-5">
              <Icon className="size-4" />
            </span>
          ) : null}
        </div>
        <p className="text-3xl font-semibold tabular-nums text-blue-7">
          <AnimatedNumber
            value={value}
            prefix={prefix}
            suffix={suffix}
            decimals={decimals}
            useLocale={useLocale}
          />
        </p>
        <p className="text-xs text-blue-4">{subtitle}</p>
      </CardContent>
    </Card>
  )
}
